export interface PolicyholderValidationState {
  person: 'policyholder' | 'participant'
  participantIndex?: number
}

export const getValidationTarget = (
  state: PolicyholderValidationState | null,
  shouldValidateSelf: boolean,
) => {
  if (
    state?.person === 'participant' &&
    typeof state.participantIndex === 'number' &&
    Number.isInteger(state.participantIndex) &&
    state.participantIndex >= 0
  ) {
    return `participants.${state.participantIndex}` as const
  }

  if (state?.person === 'policyholder' || shouldValidateSelf) {
    return 'policyholder' as const
  }

  return null
}
